/**
 * @generated SignedSource<<d0c763f3d5cb72f3f5b11aeaf2de9816>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Branch = "adviceAndConsulting" | "analysisAndStatistic" | "financeAccountingAndControlling" | "graphicsAndDesign" | "healthMedicineAndSocialAffairs" | "itAndSoftwareDevelopment" | "legalServices" | "marketingAndAdvertising" | "otherFieldsOfActivity" | "personnelAndHr" | "processPlanningAndQualityAssurance" | "productManagement";
export type TeamSize = "fiftyToHundred" | "oneToTen" | "overHundred" | "tenToTwentyFive" | "twentyFiveToFifty";
export type AcceptInviteWithNewUserInput = {
  adsOptIn: boolean;
  branch?: Branch | null;
  clientMutationId?: string | null;
  email: string;
  firstName: string;
  lastName: string;
  position?: string | null;
  rawPassword: string;
  teamSize?: TeamSize | null;
  token: string;
};
export type useAuthContext_AcceptInvitationWithNewUserMutation$variables = {
  input: AcceptInviteWithNewUserInput;
};
export type useAuthContext_AcceptInvitationWithNewUserMutation$data = {
  readonly Auth: {
    readonly acceptInvitationWithNewUser: {
      readonly loginResult: {
        readonly isAVGSClient: boolean;
        readonly jwtTokens: {
          readonly accessToken: string;
          readonly refreshToken: string;
        };
        readonly potentialAnalysisId: string | null;
      };
    } | null;
  };
};
export type useAuthContext_AcceptInvitationWithNewUserMutation = {
  response: useAuthContext_AcceptInvitationWithNewUserMutation$data;
  variables: useAuthContext_AcceptInvitationWithNewUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "AcceptInviteWithNewUserPayload",
        "kind": "LinkedField",
        "name": "acceptInvitationWithNewUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LoginFromWebappResult",
            "kind": "LinkedField",
            "name": "loginResult",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JwtLoginInformation",
                "kind": "LinkedField",
                "name": "jwtTokens",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshToken",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAVGSClient",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "potentialAnalysisId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_AcceptInvitationWithNewUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_AcceptInvitationWithNewUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ecb33a5b038936d0d29544dc9db47a4e",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_AcceptInvitationWithNewUserMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_AcceptInvitationWithNewUserMutation(\n  $input: AcceptInviteWithNewUserInput!\n) {\n  Auth {\n    acceptInvitationWithNewUser(input: $input) {\n      loginResult {\n        jwtTokens {\n          accessToken\n          refreshToken\n        }\n        isAVGSClient\n        potentialAnalysisId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b865fb8f79494f2d2a141eebd1988df";

export default node;
